import React from "react";
interface IconProps {
  width?: string;
  height?: string;
  className?: string;
  variant?: string;
  fill?: string;
}

function SearchIcon(props: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.width}
      height={props.height}
      fill={props?.fill ? props.fill : "currentColor"}
      viewBox="0 0 20 20"
      className={props.className}
    >
      <path
        // fill="#262626"
        fill={props?.fill ? props.fill : "currentColor"}
        d="M17.831 17.169l-4.014-4.014a6.73 6.73 0 10-.662.662l4.014 4.014a.469.469 0 00.662-.662zM2.97 8.75a5.781 5.781 0 115.781 5.781A5.788 5.788 0 012.969 8.75z"
      ></path>
    </svg>
  );
}

export default SearchIcon;
